import { put, retry, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import decryptCrmDataQuery from './decryptCrmDataQuery';

/**
 * Worker - requested by below function and carries out any async work
 */
export function* decryptCrmDataWorker(action) {
  const maxTries = 3; // 3 retries
  const delayLength = 3000; // 3 seconds
  const { payload } = action.payload;

  try {
    const requestArguments = {
      encryptedPersonalData: {
        payload,
      },
    };

    const args = {
      variables: requestArguments,
    };

    const decryptedData = yield retry(
      maxTries,
      delayLength,
      decryptCrmDataQuery,
      args
    );

    if (decryptedData) {
      yield put({
        type: 'CRM_AUTOFILL/setCrmDecryptedData',
        payload: decryptedData,
      });
    } else {
      yield put({
        type: 'CRM_AUTOFILL/decryptCrmDataFailed',
        payload: {},
      });
    }
  } catch (error) {
    yield put({
      type: 'CRM_AUTOFILL/decryptCrmDataFailed',
      payload: {},
    });
  }
}

/**
 * Redux Watcher
 */
export default function* decryptCrmDataWatcher() {
  yield takeEvery(ActionTypes.DECRYPT_CRM_DATA, decryptCrmDataWorker);
}
